<template>
  <div class="perguntas">
    <br><br>
    <h3 class="primary">Seu atendimento não foi identificado ou a pesquisa já foi respondida</h3>
  </div>
</template>

<script>
export default {
  name: 'Perguntas',
  data () {
    return {
      msg: '',
      mostarPerg: true
    }
  },
  mounted(){

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue